import { Alert, Box, Group, Stack } from '@mantine/core';
import { EmptyAreaProps } from './types';
import { IconInfoCircle } from '@tabler/icons-react';
import { emptyArea, emptyAreaClassNames } from './styles.css';
import { Fragment } from 'react';

export default function EmptyArea({ actions, message, title }: EmptyAreaProps) {
  return (
    <Alert
      className={emptyArea}
      classNames={emptyAreaClassNames}
      color="blackroomBlue"
      icon={<IconInfoCircle />}
      title={title}
    >
      <Stack gap="sm">
        {message && <Box>{message}</Box>}

        {actions && (
          <Group justify="center" gap="xs">
            {actions.map((action, index) => (
              <Fragment key={index}>{action}</Fragment>
            ))}
          </Group>
        )}
      </Stack>
    </Alert>
  );
}
